import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import "./../../bindings/bao-tree";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";

//ViewModel for Workitem Extended Search
class ExpandedSearchWorkItem {
    HTMLUrl: string = "ExpandedSearchSynoset/ExpandedWorkItem";
    Parent: any;
    DateFilterTypes = ko.observableArray([]);
    StartDateHtml = ko.observable();
    EndDateHtml = ko.observable();

    WorkItemCategoryId: KnockoutObservable<string> = ko.observable();
    Category: KnockoutObservable<string> = ko.observable();
    WorkItemCategory: KnockoutObservable<any> = ko.observable();

    WorkItemPriorityId = ko.observable();
    Priority: KnockoutObservable<string> = ko.observable();
    WorkItemPriority: KnockoutObservable<any> = ko.observable();

    DateFilterTypeKey = ko.observable();

    /**
      * (Filter) If true then show virtual items (WorkItems) on the list
      */
    ShowVirtual = ko.observable<boolean>(false);

    //DateTime Control Properties
    DateTimeBoxFromDate: Bindings.baoDateTimeBox = {
        mode: 'datetime',
        value: this.StartDateHtml,
        culture: Bao.Session.Language.Symbol(),
        minDate: ko.observable('19000101000000')
    };

    DateTimePickerFromDate: Bindings.baoDateTimePicker = {
        mode: 'datetime',
        value: this.StartDateHtml,
    }

    DateTimeBoxToDate: Bindings.baoDateTimeBox = {
        mode: 'datetime',
        value: this.EndDateHtml,
        culture: Bao.Session.Language.Symbol(),
        minDate: ko.observable('19000101000000')
    };

    DateTimePickerToDate: Bindings.baoDateTimePicker = {
        mode: 'datetime',
        value: this.EndDateHtml,
    }


    WorkItemPrioritySearcher: Bindings.baoSearcher = {
        ObjectId: this.WorkItemPriorityId,
        ObjectValue: 'WorkItemPriority',
        SearchType: 'WorkItemPriority',
        SelectedItem: this.WorkItemPriority,
        AutoComplete: true,
        AutoSearch: true
    };

    WorkItemCategorySearcher: Bindings.baoSearcher = {
        ObjectId: this.WorkItemCategoryId,
        ObjectValue: 'WorkItemCategory',
        SearchType: 'WorkItemCategory',
        SelectedItem: this.WorkItemCategory,
        AutoComplete: true,
        AutoSearch: true
    };

    constructor(parent: any) {
        this.Parent = parent;
        this.ExtendedSearchFiltersObservers();

        this.WorkItemPriority.subscribe((workItemPriority) => {
            this.Priority(workItemPriority?.WorkItemPriority);
        });

        this.WorkItemCategory.subscribe((workItemCategory) => {
            this.Category(workItemCategory?.WorkItemCategory);
        });
    }

    //Observers for filters
    ExtendedSearchFiltersObservers() {
        this.StartDateHtml.subscribe(() => {
            this.ExtendedSearchFiltersObserversCallBack();
        });

        this.EndDateHtml.subscribe((newValue) => {
            if (newValue === null) {
                this.ShowVirtual(false);
            }

            this.ExtendedSearchFiltersObserversCallBack();
        });

        this.WorkItemPriorityId.subscribe(() => {
            this.ExtendedSearchFiltersObserversCallBack();
        });

        this.WorkItemCategoryId.subscribe(() => {
            this.ExtendedSearchFiltersObserversCallBack();
        });

        this.DateFilterTypeKey.subscribe((newValue) => {
            if (newValue !== 'ValidFrom') {
                this.ShowVirtual(false);
            }

            this.ExtendedSearchFiltersObserversCallBack();
        });

        this.ShowVirtual.subscribe(() => {
            this.ExtendedSearchFiltersObserversCallBack();
        });
    }

    //CallBack method for filters observers 
    ExtendedSearchFiltersObserversCallBack() {
        this.Parent.CustomFilter(this.GetCustomFilter());
    }

    init = () => {
        return $.when(this.LoadHTML(), this.GetDateFilterTypes());
    };

    //Load HTML from Controller
    LoadHTML = () => {
        return Bao.get(this.HTMLUrl, (result) => {
            Bao.Templates[this.HTMLUrl] = result;
            this.Parent.ExpandedSearchTemplateName(this.HTMLUrl);
        });
    }

    //Get Date Type Filter
    GetDateFilterTypes = () => {
        return Bao.post("ExpandedSearchSynoset/GetExpandedWorkItemDateFilterType")
            .then((result) => {
                ko.map.fromJS(result, this.DateFilterTypes);
            });
    };

    //Get Custom Filter
    GetCustomFilter = () => {
        if (this.WorkItemCategoryId() == null && this.WorkItemPriorityId() == null
            && Bao.Utils.String.IsNullOrWhitespace(this.StartDateHtml()) && Bao.Utils.String.IsNullOrWhitespace(this.EndDateHtml())) {
            return null;
        }
        else {
            return {
                FromDate: this.StartDateHtml(),
                ToDate: this.EndDateHtml(),
                PriorityId: this.WorkItemPriorityId(),
                CategoryId: this.WorkItemCategoryId(),
                DateFilterType: this.DateFilterTypeKey(),
                ShowVirtual: this.ShowVirtual()
            };
        }
    };

    /**
     * Helper function to change the state of the ShowVirtual checkbox
     * @returns true if possible, set ShowVirtual
     */
    IsEnableShowVirtual = () => {
        return this.EndDateHtml() && this.DateFilterTypeKey() === 'ValidFrom';
    }
}
export default ExpandedSearchWorkItem;